<template>
  <div class="form-modal">
    <div class="form-modal__wrapp">
      <div
        class="form-modal__close"
        @click="hideModal"
      >
        <div class="form-modal__close-icon" />
        <div class="form-modal__close-text">
          Закрити
        </div>
      </div>
      <div class="container">
        <div class="form-modal__body">
          <FormModalTitle
            v-show="!isSuccessMessage"
            :title="get(dataForm, 'literals.formTitle')"
            :class="{'form-modal-title_second-step': isSecondStep}"
          />
    
          <form 
            ref="form"
            class="form-modal__form"
            novalidate="true"
          >
            <div 
              v-show="!isSecondStep && !isSuccessMessage"
              class="form-modal__form-steps"
            >
              <StepOneItem
                v-for="(item, index) in ideas"
                :id="index + 1"
                ref="stepOne"
                :key="item.id"
                v-model="ideas[index]"
                :nameTitle="get(dataForm, 'literals.ideaTitle')"
                :nameDescription="get(dataForm, 'literals.ideaHint')"
                :descriptionTitle="get(dataForm, 'literals.ideaDetailTitle')"
                :descriptionInfo="get(dataForm, 'literals.ideaDetailHint')"
                :fileInfo="get(dataForm, 'literals.ideaFileHint')"
                :classStudents="get(dataForm, 'classStudents')"
                :typesFile="get(dataForm, 'typesFile')"
                :name="item.name"
                :description="item.description"
                @remove="removeThisIdea(index)"
              />
              <div class="form-modal__btns">
                <BaseButton
                  :disabled="!isValid"
                  theme="white"
                  @click.native.prevent="addIdea"
                >
                  Додати ще одну ідею
                </BaseButton>
              
                <BaseButton
                  :disabled="!isValid"
                  @click.native.prevent="addSecondStep"
                >
                  Продовжити
                </BaseButton>
              </div>
            </div>
          </form>


          <div 
            v-show="isSecondStep && !isSuccessMessage"
            class="form-modal__form-steps"
          >
            <StepTwo
              ref="stepTwo"
              :title="get(dataForm, 'literals.infoTitle')"
              :description="get(dataForm, 'literals.infoHint')"
              :clearStepTwo="clearStepTwo"
              @sendForm="submitIdeas"
            />
          </div>

          <SuccessBlock
            v-show="isSuccessMessage"
            :title="get(dataForm, 'literals.finishTitle')"
            :hintText="get(dataForm, 'literals.finishText')"
          />

          <Loader
            v-show="isloader"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $axios from '@/plugins/axios'
  import get from 'lodash/get'
  import FormModalTitle from '@/components/modals/FormModalTitle'
  import StepOneItem from '@/components/forms/StepOneItem'
  import SuccessBlock from '@/components/forms/SuccessBlock'
  import StepTwo from '@/components/forms/StepTwo'
  import Loader from '@/components/shared/Loader'
  export default {

    components: {
      FormModalTitle,
      StepOneItem,
      StepTwo,
      SuccessBlock,
      Loader
    },

    data () {
      return {
        dataForm: null,
        fileError: false,
        clearStepTwo: false,
        ideas: [
          {
            name: '',
            description: '',
            files: [],
            id: new Date() * 1
          }
        ],
        isEmpty: true,
        isSecondStep: false,
        isLast: false,
        isSuccessMessage: false,
        isloader: false
      }
    },

    computed: {
      isValid () {
        return !!(!this.isEmpty && !this.fileError)
      }
    },

    watch: {
      ideas: {
        deep: true,
        handler () {
          for (let i = 0; i < this.ideas.length; i++) {
            if (this.ideas[i].name.length > 0 && this.ideas[i].description.length > 0) {
              this.isEmpty = false
            } else {
              this.isEmpty = true
            }
          }
        }
      }
    },

    created () {
      this.requestUrl = `${process.env.VUE_APP_API}/idea-form/get`
      this.sendUrl = `${process.env.VUE_APP_API}/idea-form/update-request/`
      this.$axios = $axios
      this.get = get
      this.bus.$on('fileHasError', (data) => {
        this.fileError = data
      })
    },

    async mounted () {
      this.$axios.get(this.requestUrl)
        .then(response => {
          this.dataForm = response.data
          // console.log(this.dataForm)
        })
        .catch(error => {
          console.log(error)
          this.errored = true
          this.loading = true 
        })
        .finally(() => { 
          this.loading = false 
          document.body.style.overflow = ''
        })
    },

    methods: {
      resetForm () {
        this.ideas = []
        this.ideas.push(
          {
            name: '',
            description: '',
            id: new Date() * 1
          })
        this.isSecondStep = false
        this.$refs.stepTwo.privacy = false
        this.$refs.stepTwo.agreement = false
        this.$refs.stepTwo.city = ''
        this.$refs.stepTwo.email = ''
        this.$refs.stepTwo.name = ''
        this.$refs.stepTwo.$el.querySelector('.input__field_phone').value = ''
        this.$refs.stepTwo.profession = ''

        // console.log(inputs)
        this.isSuccessMessage = false
      },
      hideModal () {
        this.isSecondStep = false
        if (this.isSuccessMessage) {
          // console.log('success')
          this.resetForm()
        }
        this.isSuccessMessage = false

        
        this.bus.$emit('hideModal')
      },
      addIdea () {
        this.bus.$emit('addNewIdea')
        this.ideas.push(
          {
            name: '',
            description: '',
            id: new Date() * 1
          }
        )
      },
      removeThisIdea (index) {
        this.ideas.splice(index, 1)
      },
      addSecondStep () {
        this.isSecondStep = true
      },
      async submitIdeas (token) {
        // console.log(this.$refs.stepOne)
        for (let i = 0; i < this.$refs.stepOne.length; i++) {
          const body = new FormData()

          this.ideas[i].files.forEach(file => {
            body.append('Files', file)
          })

          this.$refs.stepOne[i].ClassStudentsIds.forEach(item => {
            body.append('ClassStudentsIds', item.id)
          })

          this.$refs.stepOne[i].TypeFileIds.forEach(item => {
            body.append('TypeFileIds', item.id)
          })

          body.append('Name', this.ideas[i].name)
          body.append('Description', this.ideas[i].description)

          if (i === this.$refs.stepOne.length - 1) {
            this.isLast = true
            body.append('IsLast', true)
          }
          // this.isloader = true
          await this.$axios.post(`${this.sendUrl}${token}`, body, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
            .then(response => {
              if (this.isLast && response.status === 200 && response.request.readyState === 4) {
                this.isSuccessMessage = true
              }
              this.isloader = true
              // this.resetForm()
            })
            .catch(error => {
              console.log(error)
            })
            .finally(() => { 
              // console.log('isready')
              if (this.isLast) {
                this.isloader = false
              }
            })
        }
      }
    }
    
  }
</script>

<style lang="scss">
.form-modal {
  position: fixed;
  width: 100%;
  height: 100vh;
  z-index: 999;
  background-color: $c-white;
  padding: 214px 0 90px;
  overflow: auto;

  @include mobile {
    padding-top: 150px;
  }

  &__wrapp,
  &__body,
  .container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-height: 100%;
  }

  &__close {
    position: absolute;
    top: 48px;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;

    &-icon {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: 2px solid #000;
      position: relative;
      margin: 0 auto;
      margin-bottom: 8px;

      @include mobile {
        width: 24px;
        height: 24px;
      }

      &::before,
      &::after {
        position: absolute;
        top: 13px;
        left: 8px;
        width: 12px;
        height: 2px;
        background-color: $c-black;
        transform: rotate(45deg);
        content: '';

        @include mobile {
          width: 10px;
          top: 9px;
          left: 5px;
        }
      }

      &::after {
        transform: rotate(-45deg);
      }
    }

    &-text {
      text-transform: uppercase;
      font-size: 24px;
      line-height: 1.34;

      @include mobile {
        font-size: 14px;
        line-height: 1.34;
      }
    }
  }

  &__form {
    width: 100%;
    max-width: 669px;
    margin: 0 auto;
  }

  &__btns {
    margin-top: 58px;
    display: flex;
    justify-content: space-between;
    

    @include mobile {
      margin-top: 48px;
      flex-wrap: wrap;
    }

    button {
      min-width: calc(50% - 10px);

      @include mobile {
        width: 100%;
        margin-bottom: 16px;
        padding: 16px 20px;

        &.button--white {
          padding: 14px 20px;
        }
      }
    }
  }
}
</style>
